<template>
  <div>
    <tab custom-bar-width="80px">
      <tab-item selected @on-item-click="getOrderList()" @click.native="status='pending'">未付款</tab-item>
      <tab-item @on-item-click="getOrderList()" @click.native="status='paid'">已付款</tab-item>
      <tab-item @on-item-click="getOrderList()" @click.native="status='all'" >全部訂單</tab-item>
    </tab>
    <div v-for="order in orderList.list">
      <Order :order="order" @updateOrderList="getOrderList" @deliveryAlert="alertOrderStatus"></Order>
      
    </div>
    <x-button @click.native="loadMore()" v-if="orderList.total!=0 && orderList.list.length%10 == 0" class="my-3 loadMoreBtn" style="width:50%" type="primary" :plain="true">{{$t('product.list.loadMore')}}</x-button>

    <div class="container text-center" v-if="orderList.total <1" ><span class="emptyTextStyle">{{$t('cart.emptyMsg.order')}}</span></div>
    <div class="mt-5" style="height: 50px; ">
      <b-button  variant="success" class="footer-button" @click="$router.push('/account')">{{$t('kol.footer.goBackAccount')}}</b-button>
    </div>
    <div v-transfer-dom>
      <alert v-model="alert" title="提醒" :button-text="$t('general.confirm')" @click.native="$router.push('/account')">未能獲得訂單列表，請稍後再試</alert>
      <alert v-if="disableAlert == false" v-model="deliveryAlert" title="提醒" :button-text="$t('general.confirm')" @click.native="disableDeliveryAlert" >你有未確認收貨的訂單﹐請查閱訂單列表﹐並確認收貨</alert>
    </div>
  </div>
</template>
<script type="text/javascript">

import Order from '../components/Order'
import { Tab, TabItem, XHeader, Swiper, SwiperItem, TransferDomDirective as TransferDom, Alert } from 'vux'
import { mapGetters, } from 'vuex'
import moment from 'moment'
 
export default {
  name: 'OrderList',
  directives: {
    TransferDom
  },    
  components: {
    Order,
    Tab,
    TabItem,
    XHeader,
    Swiper, 
    SwiperItem,
    Alert,
    TransferDom
  },
  props: {},
  data() {
    return {
      orderList:{
        list:[],
        total:0
      },
      count:10,
      status:'pending',
      alert: false,
      deliveryAlert: false,
      disableAlert: false,
    }
  },
  created() {
    document.title = this.$t('kol.footer.orderList');
    this.$store.commit("hideFooter", true);
    this.getOrderList();
  },
  mounted() {},
  watch: {
    //simple sorting, need to be fixed when array list become longer
    orderList(){
      let list = this.orderList.list
      for(let i = 0; i < list.length; i++){
        for(let j = i+1; j < list.length - 1; j++){
          if(moment().diff(moment(list[j].deliveryTime),'days') > 7 && list[j].orderStatus == 'D' || list[j].orderStatus == 'D'){
            let tmp = list[i]
            list[i] = list[j];
            list[j] = tmp;
          }
        }
      }
    }
  },
  computed: {},
  methods: {
    getOrderList(){
      this.$store.dispatch('Cart/getOrderList', {
      count:this.count,
      paymentStatus: this.categorise()
    })
    .then((json) => {
      
      if(json.status == 401){
        Cookies.remove('token');
        this.$router.push('/login?type=1');
      }else if(json.status == 200){
        this.orderList = json.data
      }else{
        this.alert = !this.alert
      }
    }).catch((err) => {
      console.error(err);
    });
    },
    loadMore(){
      this.count += 10;
      this.getOrderList();
    },
    categorise() {
      if(this.status=== 'all' | ''){
        return 
      }else if(this.status=== 'paid'){
        return 'S'
      }else if(this.status=== 'pending'){
        return 'P'
      }
    },
    alertOrderStatus(){
      this.deliveryAlert = true
    },
    disableDeliveryAlert(){
      this.disableAlert = true
    }
  },
}

</script>
<style type="text/css">
.checkout-footer{
  overflow:hidden; position: 
  fixed;bottom: 0px;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/Cart/containers/OrderList.vue